import { MazakaInput } from "apps/Common/MazakaInput";

const Search = () => {
    return ( <>
    
    <MazakaInput
    xs={24}
    name="Title"
    placeholder="Ara..."
    className="!border-t-0"

/>
    </> );
}
 
export default Search;